const initFeaturedNonCritical = () => {
  const compareListStorage = localStorage.getItem('comparelist');
  const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
  if (comparelistContainer) {
    const comparelistOrganizer = document.querySelector('.compare-counter');
    const compareLimit = 3;
    let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];

    if (compareList.length && compareList.length >= compareLimit) {
      comparelistContainer.classList.add('--limit-exceed');
    } else {
      comparelistContainer.classList.remove('--limit-exceed');
    }

    if (comparelistOrganizer) {
      comparelistOrganizer.innerText = compareList.length;
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if (compareList.length === 0) {
        modalOpener.classList.add('hidden');
      } else if (compareList.length === 1) {
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      } else {
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
    }
  }

  const currentUrl = window.location.href;
  if (currentUrl.includes('form_type=contact') || currentUrl.includes('contact_posted=true')) {
    const url = new URL(currentUrl);
    const formType = url.searchParams.get('form_type');
    const contactPosted = url.searchParams.get('contact_posted');

    if (formType === 'contact' || contactPosted === 'true') {
      var hashIndex = currentUrl.indexOf('#');
      const popup =
        hashIndex !== -1
          ? document.getElementById(currentUrl.slice(hashIndex + 1))?.closest('modal-component')
          : document.querySelector('[data-modal="modal-question-ask"]');
      if (popup) popup.open();
    }
  }
};

if ('requestIdleCallback' in window) {
  requestIdleCallback(initFeaturedNonCritical);
} else {
  setTimeout(initFeaturedNonCritical, 50);
}
const getJsonParse = (attrStr) => {
  let arr = [];
  const strArr = attrStr ? JSON.parse(attrStr) : null;
  if (!strArr) return (arr = null);
  strArr.forEach((selector) => arr.push(document.querySelector(selector)));
  return arr;
};
const sectionArrRender = (secArr, response) => {
  secArr.forEach((section) => {
    const html = new DOMParser()
      .parseFromString(response.sections[section.id], 'text/html')
      .getElementById(section.id);
    section.selectors.forEach((selector) => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.outerHTML = sourceElement.outerHTML;
      }
    });
  });
};
const fetchAtc = (sections, config, element, loaderSelector) => {
  this.error = true;
  togglerLoader(true, loaderSelector);
  atcError(null, element, false);
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (!response.sections) return atcError(response, element, true);
      this.error = false;
      sectionArrRender(sections, response);
    })
    .catch((e) => {
      console.log(e);
      throw e;
    })
    .finally(() => {
      resetQty(element.dataset.form);
      togglerLoader(false, loaderSelector);
      if (!this.error) {
        if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
        if (element.dataset.modal === 'true') {
          const drawerToggler = document.querySelector(element.dataset.modalRef);
          if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
        }
        if (element.recipientForm) element.recipientForm.resetRecipientForm();
      }
    });
};
const onVariantChange = (
  jsonSelector,
  optSet,
  formsSelector,
  renders,
  parentSelector,
  gallerySelectors,
  sectionId,
  productUrl,
  updateUrl,
  focusSelector,
  renderMedia,
  templateSelector,
  loaderSelector,
  checkBundle = false
) => {
  const json = document.querySelector(jsonSelector);
  if (!json) return;
  const data = JSON.parse(json.textContent);
  const variants = data.variants;
  this.currentVariant = variants.find((variant) =>
    variant.options.every((option, index) => option === optSet[index])
  );
  setStatuses(this.currentVariant, formsSelector, renders, parentSelector, checkBundle);
  if (!this.currentVariant) return;
  if (this.currentVariant.featured_image)
    setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
  renderVariant(
    renders,
    this.currentVariant.id,
    parentSelector,
    productUrl,
    sectionId,
    updateUrl,
    focusSelector,
    loaderSelector
  );
};
const setStatuses = (variant, formElems, renderElems, parentElem, checkBundle) => {
  const forms = getJsonParse(formElems);
  forms.forEach((form) => {
    if (!form) return;
    const atcBtn = checkBundle ? form.querySelector('[data-bundle-toggler]') : form.querySelector('[name="add"]');
    if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
    toggleAvail(true, renderElems, parentElem);
    const input = form.querySelector('[name="id"]');
    input.value = variant.id;
    if (!atcBtn) return;
    const textContainer = atcBtn.querySelector('[data-atc-text]');
    if (variant.available) {
      textContainer.innerText = textContainer.dataset.textAvail;
      atcBtn.removeAttribute('disabled');
      atcBtn.classList.remove('--disabled');
      return;
    }
    textContainer.innerText = textContainer.dataset.textSold;
    atcBtn.setAttribute('disabled', '');
    atcBtn.classList.add('--disabled');
  });
};
const toggleAvail = (flag, selectors, parent, btn) => {
  const arr = JSON.parse(selectors);
  const parentElem = document.querySelector(parent);
  arr.forEach((selector) => {
    const element = parentElem.querySelector(selector);
    if (!element) return;
    flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
  });
  if (!btn) return;
  const textContainer = btn.querySelector('[data-atc-text]');
  textContainer.innerText = textContainer.dataset.textUnavail;
  btn.setAttribute('disabled', '');
};
const setGallery = (imageId, galleries, render, template) => {
  const arr = JSON.parse(galleries);
  if (!arr) return;
  if (render) {
    const templateElem = document.querySelector(template);
    const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
    const imageContainer = document.querySelector(arr[0]);
    var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
    var newOpacity = currentOpacity === 1 ? 0 : 1;
    imageContainer.style.transition = 'opacity 0.3s ease';
    imageContainer.style.opacity = newOpacity;
    imageContainer.classList.remove('.imageContainer');
    setTimeout(() => {
      imageContainer.innerHTML = templateElement.outerHTML;
      setTimeout(() => {
        imageContainer.style.opacity = 1;
      }, 0);
    }, 500);
    return;
  }
  arr.forEach((gallery) => {
    const gal = document.querySelector(gallery);
    if (!gal) return;
    switch (gal.slider) {
      case undefined:
        let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
        const activeIndex = items.findIndex((item) => item.dataset.mediaId == imageId);
        if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
        items.unshift(items.splice(activeIndex, 1)[0]);
        gal.innerHTML = '';
        gal.classList.add('--swapped');
        gal.append(...items);
        break;
      default:
        const splide = gal.slider;
        const slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
        splide.go(slide[0].index);
        break;
    }
  });
};
const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector, loaderSelector) => {
  togglerLoader(true, loaderSelector);
  fetch(`${url}?variant=${id}&section_id=${section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const parentElement = document.querySelector(parent);
      const arr = JSON.parse(elems);
      arr.forEach((selector) => {
        const element = parentElement.querySelector(selector);
        if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
      });
    })
    .catch((e) => {
      console.error(e);
      throw e;
    })
    .finally(() => {
      if (updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${id}`);
      if (focusSelector) {
        const focusParent = document.querySelector(focusSelector);
        trapFocus(focusParent.content ? focusParent.content : focusParent);
      }
      togglerLoader(false, loaderSelector);
    });
};
const resetQty = (elem) => {
  const form = document.querySelector(elem);
  if (!form) return;
  const qtyField = form.quantity;
  qtyField.value = parseFloat(qtyField.min);
  qtyField.dispatchEvent(new Event('input'));
};
const atcError = (response, elem, flag) => {
  const errElem = document.querySelector(elem.dataset.errorSelector);
  const errSpan = errElem.querySelector('[data-error]');
  const recepForm = elem.form.querySelector('recipient-form');
  if (!flag) {
    errElem.classList.add('hidden');
    errSpan.innerText = '';
    if (recepForm) recepForm.clearErrorMessage();
    return;
  }
  if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
  if (typeof response.description !== 'object') {
    errElem.classList.remove('hidden');
    errSpan.innerText = response.description;
  }
  resetQty(elem.dataset.form);
};
class VariantPill extends HTMLElement {
  constructor() {
    super();

    this.variantChange = this.onInputChange.bind(this);
    this.addEventListener('change', this.variantChange);
    this.addEventListener('click', this.onClick.bind(this));
  }

  connectedCallback() {
    const parent = document.querySelector(this.dataset.parent);
    if (parent) {
      const currentSet = this.dataset.currentSet ? JSON.parse(this.dataset.currentSet) : [];
      if (currentSet.length > 0) this.updateOptionsAvailability(parent, currentSet);
    }
  }

  onClick(event) {
    const label = event.target.closest('label');
    if (label && label.htmlFor) {
      const input = document.getElementById(label.htmlFor) || this.querySelector(`input[id="${label.htmlFor}"]`);
      if (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
          if (selectedValueSpan) {
            selectedValueSpan.textContent = input.value;
          }
          this.setVariantOptions(input.value);
        }
        return;
      }
    }
    const radio = event.target.closest('input[type="radio"]');
    if (radio) {
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = radio.value;
      }
      this.setVariantOptions(radio.value);
      return;
    }
    const btn = event.target.closest('.product-variant-swatch-btn, [data-btn-variant]');
    if (btn && btn.dataset.value) {
      const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
      if (selectedValueSpan) {
        selectedValueSpan.textContent = btn.dataset.value;
      }
      this.setVariantOptions(btn.dataset.value);
    }
  }

  onInputChange(event) {
    const input = (event && event.target && event.target.matches && event.target.matches('input[type="radio"]'))
      ? event.target
      : this.querySelector('input[type="radio"]:checked');
    if (!input) return;
    const selectedValueSpan = this.closest('.variant-row')?.querySelector('.variant-row_selected-value');
    if (selectedValueSpan) {
      selectedValueSpan.textContent = input.value;
    }
    this.setVariantOptions(input.value);
  }

  setVariantOptions(value) {
    const parent = document.querySelector(this.dataset.parent);
    const mainParent = document.querySelector(this.dataset.mainParent);
    const errElem = document.querySelector(this.dataset.errorSelector);
    if (!parent) return;

    if (mainParent && mainParent.hasAttribute('data-bundle-included')) {
      const bundleCalculator = document.querySelector('bundle-calculator');
      mainParent.removeAttribute('data-bundle-included');
      bundleCalculator.init(null, null, null, null, parseFloat(mainParent.dataset.bundleVariant));
    }
    if (errElem) errElem.classList.add('hidden');

    const currentSet = JSON.parse(this.dataset.currentSet);
    const index = parseInt(this.dataset.optionIndex);
    currentSet[index] = value;

    this.updateOptionsAvailability(parent, currentSet);

    let availableSet = null;
    if (this.dataset.checkSets === 'true' && this.dataset.availableSets) {
      const sets = JSON.parse(this.dataset.availableSets);
      const checkSet = (val) => {
        if (!val || !Array.isArray(sets)) return null;
        return sets.find((set) => Array.isArray(set) && set.includes(val)) || null;
      };
      availableSet = checkSet(value);
    }

    onVariantChange(
      this.dataset.jsonSelector,
      availableSet ? availableSet : currentSet,
      this.dataset.forms,
      this.dataset.renders,
      this.dataset.mainParent,
      this.dataset.galleries,
      this.dataset.sectionId,
      this.dataset.productUrl,
      this.dataset.updateUrl,
      this.dataset.focusSelector ? this.dataset.focusSelector : null,
      this.dataset.mediaTemplate === 'true',
      this.dataset.template,
      this.dataset.loader ? this.dataset.loader : null,
      this.dataset.bundle === 'true'
    );
  }

  updateOptionsAvailability(parentOrElems, set) {
    const json = document.querySelector(this.dataset.jsonSelector);
    if (!json) return;
    let data;
    try {
      data = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    const variants = data && data.variants;
    if (!variants || !Array.isArray(variants)) return;

    const elems = parentOrElems instanceof HTMLElement
      ? parentOrElems.querySelectorAll('variant-pill, variant-dropdown')
      : parentOrElems;

    elems.forEach((select) => {
      select.setAttribute('data-current-set', JSON.stringify(set));
      const optionIndex = parseInt(select.dataset.optionIndex);
      if (isNaN(optionIndex)) return;

      const isCheckSets = select.dataset.checkSets === 'true';

      const radioInputs = select.querySelectorAll('input[type="radio"]');
      if (radioInputs.length > 0) {
        radioInputs.forEach((input) => {
          const val = input.value || input.getAttribute('value');
          if (val === undefined) return;

          const isAvailable = variants.some((v) => {
            if (!v.available) return false;
            const vVal = v.options ? v.options[optionIndex] : v[`option${optionIndex + 1}`];
            if (vVal !== val) return false;
            if (isCheckSets) return true; // Early return for independent sets
            for (let k = 0; k < optionIndex; k++) {
              const prevVal = v.options ? v.options[k] : v[`option${k + 1}`];
              if (prevVal !== set[k]) return false;
            }
            return true;
          });

          const label = input.nextElementSibling || select.querySelector(`label[for="${input.id}"]`);
          const labelText = label ? label.querySelector('[data-variant-status-text]') : null;

          if (isAvailable) {
            input.classList.remove('disabled');
            if (labelText) {
              labelText.classList.add('hidden');
              labelText.classList.remove('visually-hidden');
            }
          } else {
            input.classList.add('disabled');
            if (labelText) {
              labelText.classList.remove('hidden');
              labelText.classList.add('visually-hidden');
            }
          }

          if (input.checked || val === set[optionIndex]) {
            const selectedValueSpan = select.closest('.variant-row')?.querySelector('.variant-row_selected-value');
            if (selectedValueSpan) {
              selectedValueSpan.textContent = val;
            }
          }
        });
      }
    });
  }
}

if (!customElements.get('variant-pill')) {
  customElements.define('variant-pill', VariantPill);
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();

    const onButtonClick = (event) => {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === 'plus' || event.target.parentElement.name === 'plus'
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    };

    const setBtnStatus = (type, value) => {
      const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
      const btn =
        type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
      switch (type) {
        case 'min':
          btn.classList.toggle('disabled', value <= currVal);
          btn.toggleAttribute('disabled', value <= currVal);
          break;
        case 'max':
          btn.classList.toggle('disabled', value >= currVal);
          btn.toggleAttribute('disabled', value >= currVal);
          break;
        default:
          console.log('no button found');
          break;
      }
    };

    const setSubtotals = (qty, elem) => {
      const total = qty * parseInt(this.dataset.variantPrice);
      elem.innerHTML = Shopify.formatMoney(total, window.money_format);
    };

    const onInputChange = () => {
      const value = parseInt(this.input.value);
      const qtySubtotal = this.querySelector('[data-qty-subtotal]');
      this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
      if (!qtySubtotal) return;
      setSubtotals(value, qtySubtotal);
    };

    const setListeners = () => {
      this.changeEvent = new Event('input', { bubbles: true });
      this.inputChange = onInputChange.bind(this);
      this.buttonClick = onButtonClick.bind(this);
      this.input.addEventListener('input', this.inputChange);
      this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
    };

    const initialize = () => {
      this.input = this.querySelector('input');
      if (!this.input) return;
      setListeners();
    };
    initialize();
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
class AtcSubmit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = document.querySelector(this.dataset.form);
    if (!this.form) return;
    this.recipientForm = this.form.querySelector('recipient-form');
    this.submit = this.onAddToCart.bind(this);
    this.form.addEventListener('submit', this.submit);
  }

  onAddToCart(event) {
    event.preventDefault();
    this.error = false;
    const secArr = JSON.parse(this.dataset.sections);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append(
      'sections',
      secArr.map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;
    fetchAtc(secArr, config, this, this.dataset.loader);
  }
}
if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
class AtcBundleToggler extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = document.querySelector(this.dataset.form);
    if (!this.form) return;
    const onBundleSubmit = (event) => {
      event.preventDefault();
      const parent = document.querySelector(this.dataset.mainParent);
      const btnSpan = parent.querySelector('[data-atc-text]');
      const formData = new FormData(this.form);
      const mediaElement = document.querySelector(this.dataset.gallery);
      const bundleCalculator = document.querySelector('bundle-calculator');
      bundleCalculator.init(
        mediaElement,
        parseInt(formData.get('id')),
        formData.get('variant_price'),
        formData.get('variant_compare_price')
      );
      if (!parent.hasAttribute('data-bundle-included')) {
        btnSpan.innerText = btnSpan.dataset.removeText;
        parent.setAttribute('data-bundle-included', '');
        parent.setAttribute('data-bundle-variant', parseInt(formData.get('id')));
      } else {
        btnSpan.innerText = btnSpan.dataset.textAvail;
        parent.removeAttribute('data-bundle-included');
        parent.removeAttribute('data-bundle-variant');
      }
    };
    this.form.addEventListener('submit', onBundleSubmit);
  }

  onRemoval() {
    const parent = document.querySelector(this.dataset.mainParent);
    const btnSpan = parent.querySelector('[data-atc-text]');
    btnSpan.innerText = btnSpan.dataset.textAvail;
    parent.removeAttribute('data-bundle-included');
    parent.removeAttribute('data-bundle-variant');
  }
}
if (!customElements.get('atc-bundle-toggler')) customElements.define('atc-bundle-toggler', AtcBundleToggler);
class BundleCalculator extends HTMLElement {
  constructor() {
    super();

    this.arr = [];
    this.list = this.querySelector('[data-thumbnails-list]');
    this.btn = this.querySelector('[data-bundle-atc-btn]');
    if (this.btn) this.btn.addEventListener('click', this.onBundleSubmit.bind(this));
  }

  init(media, variant, price, comparePrice, removeId = null) {
    const createDataset = (id, price, comparePrice, media) => {
      const index = this.arr.findIndex((item) => item.variant === id);
      if (index === -1)
        return this.arr.push({
          variant: id,
          media: media,
          price: parseInt(price),
          comparePrice: parseInt(comparePrice),
        });
      this.arr.splice(index, 1);
    };
    const updateStats = (price, comparePrice, count) => {
      const bundleNumElement = this.querySelector('[data-num-count]');
      const bundlePriceElement = this.querySelector('[data-bundle-price]');
      const bundleComparePriceElement = this.querySelector('[data-bundle-compare-price]');
      const bundleAtcBtn = this.querySelector('[data-bundle-atc-btn]');
      bundlePriceElement.innerText = Shopify.formatMoney(price, window.money_format);
      if (comparePrice === price) {
        bundleComparePriceElement.classList.add('hidden');
      } else {
        bundleComparePriceElement.innerText = Shopify.formatMoney(comparePrice, window.money_format);
        bundleComparePriceElement.classList.remove('hidden');
      }
      if (count === 0) {
        bundleNumElement.classList.add('hidden');
        bundleAtcBtn.classList.add('disabled');
        return;
      }
      bundleNumElement.innerText = count;
      bundleNumElement.classList.remove('hidden');
      bundleAtcBtn.classList.remove('disabled');
    };
    const renderDataList = () => {
      let bundlePrice = 0;
      let bundleComparePrice = 0;
      this.resetThumbsList();
      this.arr.forEach((product) => {
        const thumbItem = document.createElement('li');
        this.list.appendChild(thumbItem);
        if (product.media) thumbItem.style.backgroundImage = `url('${product.media.src}')`;
        this.list.appendChild(thumbItem);
        bundlePrice += product.price;
        bundleComparePrice += product.comparePrice !== 0 ? product.comparePrice : product.price;
      });
      updateStats(bundlePrice, bundleComparePrice, this.arr.length);
    };
    if (removeId) {
      const index = this.arr.findIndex((item) => item.variant === removeId);
      this.arr.splice(index, 1);
      renderDataList();
      return;
    }
    createDataset(variant, price, comparePrice, media);
    renderDataList();
  }

  resetThumbsList() {
    while (this.list.firstChild) {
      this.list.removeChild(this.list.firstChild);
    }
  }

  onBundleSubmit(event) {
    event.preventDefault();
    const runAtc = () => {
      togglerLoader(true, this.dataset.loaderSelector);
      if (this.arr.length > 0) {
        const product = this.arr[0];
        fetchBundleAtc(product);
        return;
      }
      togglerLoader(false, this.dataset.loaderSelector);
      if (this.dataset.redirect) return (window.location.href = this.dataset.redirect);
      if (this.dataset.modal === 'true') {
        const drawerToggler = document.querySelector(this.dataset.modalRef);
        if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
      }
    };
    const fetchBundleAtc = (product) => {
      const secArr = JSON.parse(this.dataset.sections);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData();
      formData.append(
        'sections',
        secArr.map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      formData.append('id', product.variant);
      formData.append('quantity', 1);
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          sectionArrRender(secArr, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const parentCard = document.querySelector(
            `[data-bundle-included][data-bundle-variant="${product.variant}"]`
          );
          const toggler = parentCard.querySelector('atc-bundle-toggler');
          toggler.onRemoval();
          this.init(null, null, null, null, product.variant);
          runAtc();
        });
    };
    runAtc();
  }
}
if (!customElements.get('bundle-calculator')) customElements.define('bundle-calculator', BundleCalculator);
const lineItemUpdate = (line, quantity, sections, parent) => {
  togglerLoader(true);
  const secArr = JSON.parse(sections);
  var body = JSON.stringify({
    line,
    quantity,
    sections: secArr.map((section) => section.id),
    sections_url: window.location.pathname,
  });
  this.erorr = false;
  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const response = JSON.parse(responseText);
      if (response.errors) return handleLineError(parent, response);
      sectionArrRender(secArr, response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (!this.erorr) {
        const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
        if (modal) {
          if (modal.classList.contains('modal--active')) {
            trapFocus(modal.content);
            modal.setListeners(true);
          }
        }
      }
      togglerLoader(false);
    });
};
class LineItemQty extends QuantityInput {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inputUpdate = this.querySelector('[name="updates[]"]');
    this.debouncedOnUpdate = debounce((event) => {
      this.onLineItemUpdate(event);
    }, 500);
    this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
  }

  onLineItemUpdate() {
    const qty = parseInt(this.querySelector('[name="updates[]"]').value);
    lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
  }
}
if (!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);
class LineItemRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    if (!this.button) return;

    const onRemoval = (event) => {
      event.preventDefault();
      lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector);
    };
    this.removal = onRemoval.bind(this);
    this.button.addEventListener('click', this.removal);
  }
}
if (!customElements.get('line-item-remove')) customElements.define('line-item-remove', LineItemRemoveButton);
class DropdownToggler extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('[data-btn-toggler]');
    if (!this.button) return;
    const onHandleClick = (event) => {
      event.preventDefault();
      const parent = document.querySelector(this.dataset.parent);
      parent.classList.toggle(this.dataset.activeClass);
    };
    this.handleClick = onHandleClick.bind(this);
    this.button.addEventListener('click', this.handleClick);
  }
}
if (!customElements.get('dropdown-toggler')) customElements.define('dropdown-toggler', DropdownToggler);
if (!customElements.get('product-compare-button')) {
  customElements.define(
    'product-compare-button',
    class ProductCompareButton extends HTMLElement {
      constructor() {
        super();

        this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
        this.anchor.addEventListener('click', this.onCompare.bind(this));
      }

      connectedCallback() {
        this.checkComparelistStatus();
      }

      onCompare() {
        event.preventDefault();
        if (!this.dataset.handle) return;

        const handle = this.dataset.handle;
        const compareListStorage = localStorage.getItem('comparelist');
        const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
        const comparelistOrganizer = document.querySelector('.compare-counter');
        let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
        const compareLimit = 3;

        if (!compareList.includes(handle)) {
          if (compareList.length && compareList.length >= compareLimit) {
            comparelistContainer.classList.add('--limit-exceed');

            alert(window.additionalStrings.compare.limitExceed);
            return;
          } else {
            compareList.push(handle);
            comparelistContainer.classList.remove('--limit-exceed');
          }
        } else {
          var index = compareList.indexOf(handle);

          if (index !== -1) {
            compareList.splice(index, 1);
          }
        }
        localStorage.setItem('comparelist', JSON.stringify(compareList));

        const modalOpener = document.querySelector('[data-modal-main="compare"]');

        if (compareList.length === 0) {
          modalOpener.classList.add('hidden');
        } else if (compareList.length === 1) {
          modalOpener.classList.remove('hidden');
          modalOpener.classList.add('--disabled');
        } else {
          modalOpener.classList.remove('--disabled');
          modalOpener.classList.remove('hidden');
        }

        if (comparelistOrganizer) {
          comparelistOrganizer.innerText = compareList.length;
        }

        this.checkComparelistStatus();
      }

      checkComparelistStatus() {
        if (!this.dataset.handle) return;

        const allBtns = document.querySelectorAll('product-compare-button');
        const compareListStorage = localStorage.getItem('comparelist');
        const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];

        allBtns.forEach((btn) => {
          const handle = btn.dataset.handle;
          const anchor = btn.querySelector('a');
          const text = btn.querySelector('.pwb-text');

          if (compareList.includes(handle)) {
            anchor.classList.add('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace(
              '[product_name]',
              btn.dataset.product
            );
          } else {
            anchor.classList.remove('--compare-active');
            text.innerHTML = window.accessibilityStrings.compareAddbutton.replace(
              '[product_name]',
              btn.dataset.product
            );
          }
        });
      }
    }
  );
}
